export default __webpack_public_path__ + "static/media/software.39151a47.png";